import React from 'react';
import {AiReportsProvider} from '../context/AiReportsContext';
import {AiReportsCard} from './AiReportsCard';
import {AiReportsLoadingDialog} from './AiReportsLoadingDialog';

export function AiReportsPage() {
  return (
    <AiReportsProvider>
      <AiReportsLoadingDialog/>
      <AiReportsCard/>
    </AiReportsProvider>
  );
}
